// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___mLvyf","totalContainer":"totalContainer___IhisN"};